import DBContainer from '../lib/db'

export default class WebmangoWorkspaceDB extends DBContainer {
  constructor (id, webmango) {
    super(id, {
      prefix: 'workspace',
      dbNames: [
        'workspace',
        'processes',
        'jobs',
        'tasks',
        'workflows'
      ]
    }, webmango)
  }

  /**
   * Processes
   */

  processPut (id, data) {
    return this.processesDB.replace(id, data)
  }

  processRemove (id) {
    return this.processesDB.delete(id)
  }

  processList () {
    return this.processesDB.hoodieApi().findAll()
  }

  processGet (selector) {
    return this.processesDB.findOne({
      selector
    })
  }
}



// WEBPACK FOOTER //
// ../webmango-api/workspace/db.js